/* Maison Lamora — glass library: 217 hand-blown pieces, searchable by family and SKU. */
(function () {
  function init() {
    var root = document.querySelector('[data-library]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var D = window.LAMORA_DATA, L = window.LAMORA;
    var grid = root.querySelector('[data-lib-grid]');
    var chips = root.querySelector('[data-lib-families]');
    var search = root.querySelector('[data-lib-search]');
    var count = root.querySelector('[data-lib-count]');
    var state = { family: 'all', q: '' };

    // which pieces are selectable in the configurator
    var configurable = {};
    D.elements.forEach(function (e) { e.tones.forEach(function (t) { configurable[t.sku] = { element: e.id, tone: t.id, label: e.label + ' · ' + t.label }; }); });

    var counts = D.library.reduce(function (m, p) { m[p.family] = (m[p.family] || 0) + 1; return m; }, {});
    var fams = [['all', 'All', D.library.length]].concat(D.families.map(function (f) { return [f[0], f[0], counts[f[0]] || 0]; }));
    chips.innerHTML = fams.map(function (f) {
      return '<button type="button" class="chip' + (f[0] === 'all' ? ' is-active' : '') + '" data-family="' + f[0] + '">' + f[1] + ' <span class="chip__n">' + f[2] + '</span></button>';
    }).join('');
    chips.addEventListener('click', function (e) {
      var b = e.target.closest('[data-family]');
      if (!b) return;
      state.family = b.dataset.family;
      chips.querySelectorAll('.chip').forEach(function (c) { c.classList.toggle('is-active', c === b); });
      render();
    });
    if (search) search.addEventListener('input', function () { state.q = search.value.trim().toLowerCase(); render(); });

    function filtered() {
      return D.library.filter(function (p) {
        if (state.family !== 'all' && p.family !== state.family) return false;
        if (!state.q) return true;
        return (p.name + ' ' + p.sku + ' ' + p.family).toLowerCase().indexOf(state.q) > -1;
      });
    }

    function render() {
      var list = filtered();
      count.textContent = list.length + (list.length === 1 ? ' piece' : ' pieces');
      grid.innerHTML = list.map(function (p) {
        var cfg = configurable[p.sku];
        return '<article class="piece" data-sku="' + p.sku + '">' +
          '<div class="piece__img"><img loading="lazy" alt="' + p.name + '" src="' + L.pieceImage(p.sku, 640) + '" onerror="this.closest(\'.piece__img\').classList.add(\'is-missing\')"></div>' +
          '<div class="piece__info"><h3 class="piece__name">' + p.name + '</h3><p class="piece__sku">' + p.sku + '</p></div>' +
          '<div class="piece__actions">' +
          '<button type="button" class="link-btn" data-enquiry-toggle="' + p.sku + '" data-type="Glass piece" data-title="' + p.name + ' (' + p.sku + ')" data-detail="' + p.family + '" data-image="' + L.pieceImage(p.sku, 200) + '"><span data-label>Add to enquiry</span></button>' +
          (cfg ? '<a class="link-btn" href="' + L.pages.configure + '?piece=' + encodeURIComponent(p.sku) + '">Configure with this</a>' : '') +
          '</div></article>';
      }).join('');
      if (window.LAMORA && LAMORA.enquiry) LAMORA.enquiry.onChange && null;
      document.dispatchEvent(new CustomEvent('lamora:rendered'));
    }
    render();
    if (L.enquiry) L.enquiry.onChange(function () {
      grid.querySelectorAll('[data-enquiry-toggle]').forEach(function (b) {
        var on = L.enquiry.has(b.dataset.enquiryToggle);
        b.classList.toggle('is-added', on);
        b.querySelector('[data-label]').textContent = on ? 'Added' : 'Add to enquiry';
      });
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
